import { render, staticRenderFns } from "./Layout-submenu.vue?vue&type=template&id=5a40f351&"
import script from "./Layout-submenu.vue?vue&type=script&lang=js&"
export * from "./Layout-submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports